// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__i6n3s","left":"StickyBox_left__3vfaO","right":"StickyBox_right__1MWcq"};